// extracted by mini-css-extract-plugin
export var background = "fl_y";
export var bottomBackground = "fl_lX";
export var card = "fl_cS";
export var container = "fl_f";
export var darkToLight = "fl_lY";
export var normal = "fl_h3";
export var small = "fl_b4";
export var topBackground = "fl_lW";